(function () {
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  document.querySelectorAll('.events-directory').forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sd-card]'));
    var listEl = root.querySelector('[data-sd-list]');
    var emptyEl = root.querySelector('[data-sd-empty]');
    var countEl = root.querySelector('[data-sd-count]');
    var labelEl = root.querySelector('[data-sd-countlabel]');
    var msgEl = root.querySelector('[data-sd-msg]');
    var monthSel = root.querySelector('[data-ed-month]');
    var state = { type: '', veh: '', month: '', toggles: {}, origin: null, radius: 100 };
    var map, markers = {}, originLayer;

    // Hide anything that has finished (the page may be cached for a while).
    var d = new Date();
    var today = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    cards = cards.filter(function (c) {
      if (c.dataset.end && c.dataset.end < today) { c.remove(); return false; }
      return true;
    });

    // Date order, TBC last.
    function byDate(a, b) {
      var x = a.dataset.start || '9999', y = b.dataset.start || '9999';
      return x < y ? -1 : x > y ? 1 : a.dataset.name.localeCompare(b.dataset.name);
    }
    cards.sort(byDate).forEach(function (c) { listEl.insertBefore(c, emptyEl); });

    // Month options from the events themselves.
    var seen = {};
    cards.forEach(function (c) {
      var s = c.dataset.start, e = c.dataset.end || s;
      if (!s) return;
      var y = +s.slice(0, 4), m = +s.slice(5, 7), ey = +e.slice(0, 4), em = +e.slice(5, 7);
      while (y < ey || (y === ey && m <= em)) {
        seen[y + '-' + ('0' + m).slice(-2)] = true;
        m++; if (m > 12) { m = 1; y++; }
      }
    });
    Object.keys(seen).sort().forEach(function (k) {
      var o = document.createElement('option');
      o.value = k; o.textContent = MONTHS[+k.slice(5) - 1] + ' ' + k.slice(0, 4);
      monthSel.appendChild(o);
    });
    var tbc = document.createElement('option'); tbc.value = 'tbc'; tbc.textContent = 'Dates TBC'; monthSel.appendChild(tbc);

    function miles(a, b) {
      var R = 3958.8, toR = Math.PI / 180;
      var dLat = (b.lat - a.lat) * toR, dLng = (b.lng - a.lng) * toR;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }

    function inMonth(c, k) {
      if (!k) return true;
      if (k === 'tbc') return !c.dataset.start;
      if (!c.dataset.start) return false;
      return c.dataset.start.slice(0, 7) <= k && (c.dataset.end || c.dataset.start).slice(0, 7) >= k;
    }

    function activate(id) {
      cards.forEach(function (c) { c.classList.toggle('is-active', c.dataset.id === id); });
      var m = markers[id];
      if (m && map) { map.setView(m.getLatLng(), Math.max(map.getZoom(), 9)); m.openPopup(); }
    }

    function render() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (!state.type || c.dataset.type === state.type) && (!state.veh || (c.dataset.veh || '').indexOf('|' + state.veh + '|') !== -1) && inMonth(c, state.month);
        Object.keys(state.toggles).forEach(function (t) { if (state.toggles[t] && !c.dataset[t]) ok = false; });
        var dist = null;
        if (state.origin) {
          dist = miles(state.origin, { lat: parseFloat(c.dataset.lat), lng: parseFloat(c.dataset.lng) });
          if (dist > state.radius) ok = false;
        }
        c.dataset.d = dist === null ? '' : dist;
        c.querySelector('[data-sd-dist]').textContent = dist === null ? '' : Math.round(dist) + ' mi';
        c.hidden = !ok;
        if (markers[c.dataset.id] && map) { if (ok) markers[c.dataset.id].addTo(map); else map.removeLayer(markers[c.dataset.id]); }
        if (ok) shown++;
      });
      var order = cards.slice().sort(state.origin
        ? function (a, b) { return (parseFloat(a.dataset.d) || 0) - (parseFloat(b.dataset.d) || 0); }
        : byDate);
      order.forEach(function (c) { listEl.insertBefore(c, emptyEl); });
      countEl.textContent = shown === 1 ? '1 event' : shown + ' events';
      labelEl.textContent = state.origin ? 'near ' + state.origin.label + ', nearest first' : 'coming up, soonest first';
      emptyEl.hidden = shown !== 0;
    }

    root.querySelectorAll('[data-sd-filter]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest('.sd-chip'); if (!b) return;
        group.querySelectorAll('.sd-chip').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        state[group.dataset.sdFilter] = b.dataset.value;
        render();
      });
    });

    root.querySelector('[data-ed-toggles]').addEventListener('click', function (e) {
      var b = e.target.closest('.sd-chip'); if (!b) return;
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      state.toggles[b.dataset.toggle] = on;
      render();
    });

    monthSel.addEventListener('change', function () { state.month = this.value; render(); });

    listEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sd-show]'); if (!b) return;
      activate(b.closest('[data-sd-card]').dataset.id);
      var mapEl = root.querySelector('[data-sd-map]');
      var r = mapEl.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    root.querySelector('[data-sd-search]').addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = this.postcode.value.trim();
      state.radius = parseFloat(this.radius.value);
      state.month = this.month.value;
      msgEl.hidden = true;
      if (!pc) {
        state.origin = null;
        if (originLayer && map) { map.removeLayer(originLayer); originLayer = null; }
        render(); return;
      }
      var url = 'https://api.postcodes.io/' + (pc.split(' ').join('').length <= 4 ? 'outcodes/' : 'postcodes/') + encodeURIComponent(pc);
      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        if (!j || j.status !== 200 || !j.result) throw new Error('not found');
        state.origin = { lat: j.result.latitude, lng: j.result.longitude, label: pc.toUpperCase() };
        if (map) {
          if (originLayer) map.removeLayer(originLayer);
          originLayer = L.layerGroup([
            L.circle([state.origin.lat, state.origin.lng], { radius: Math.min(state.radius, 300) * 1609.34, color: '#000', weight: 1, dashArray: '4 4', fillOpacity: 0.04 }),
            L.circleMarker([state.origin.lat, state.origin.lng], { radius: 7, color: '#fff', weight: 3, fillColor: '#2B6CB0', fillOpacity: 1 })
          ]).addTo(map);
          if (state.radius < 9999) map.fitBounds(originLayer.getLayers()[0].getBounds()); else map.setView([state.origin.lat, state.origin.lng], 6);
        }
        render();
      }).catch(function () {
        msgEl.textContent = "We couldn't find that postcode. Check it and try again.";
        msgEl.hidden = false;
      });
    });

    function initMap() {
      if (typeof L === 'undefined') { return setTimeout(initMap, 150); }
      map = L.map(root.querySelector('[data-sd-map]'), { scrollWheelZoom: false });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
      var bounds = [];
      cards.forEach(function (c) {
        var lat = parseFloat(c.dataset.lat), lng = parseFloat(c.dataset.lng);
        if (isNaN(lat) || isNaN(lng)) return;
        var m = L.circleMarker([lat, lng], { radius: 9, color: '#fff', weight: 3, fillColor: root.dataset.accent || '#FD9E1A', fillOpacity: 1 })
          .bindPopup(function () {
            var box = document.createElement('div');
            var s = document.createElement('strong'); s.textContent = c.dataset.name; box.appendChild(s);
            var when = c.querySelector('.ed-when');
            if (when) { box.appendChild(document.createElement('br')); box.appendChild(document.createTextNode(when.textContent.trim())); }
            if (c.dataset.url) {
              box.appendChild(document.createElement('br'));
              var a = document.createElement('a'); a.href = c.dataset.url; a.target = '_blank'; a.rel = 'noopener';
              a.textContent = 'Event website'; a.style.fontWeight = '700'; box.appendChild(a);
            }
            return box;
          })
          .on('click', function () { activate(c.dataset.id); c.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
        m.addTo(map); markers[c.dataset.id] = m; bounds.push([lat, lng]);
      });
      if (bounds.length) map.fitBounds(bounds, { padding: [30, 30] }); else map.setView([54.5, -2.5], 5);
      render();
    }
    render();
    initMap();
  });
})();
